import React from 'react'
import LayoutNotFound from '../components/layouts/LayoutNotFound'


export default () => (
  <LayoutNotFound />
)
